import { Link } from "react-router-dom";
import styles from "./PickUpCard.module.scss";

const PickUpCard = ({ className, pickUp, minHeight }) => {
  const { city, state, zip, date, linkToClosestUnits } = pickUp || {};

  return (
    <div className={className} style={{ minHeight }}>
      <span className={styles.title}>Pick-up at:</span>
      <p className={styles.value}>
        {city}, {state}{" "}
        {linkToClosestUnits ? (
          <Link
            to={linkToClosestUnits}
            style={{ textDecoration: "underline" }}
            target="_blank"
          >
            {zip}
          </Link>
        ) : (
          zip
        )}
      </p>
      <span className={styles.title}>Pick-up date:</span>
      <p className={styles.value}>{date}</p>
    </div>
  );
};

export default PickUpCard;
